import React from "react";
import useAuthenticationStore from "./Store";
import { AuthenticationViews } from "./types";
import JoinCoordinator from "./Join";

const JoinCoordinatorContainer: React.FC = () => {
    const { state, dispatch, startJoin } = useAuthenticationStore();
    const { firstName, email, lastName, isLoading, serverError } = state;

    const setEmail = (newEmail: string) => {
        dispatch({ type: "SET_EMAIL", payload: newEmail });
    };
    const setFirstName = (newFirstName: string) => {
        dispatch({ type: "SET_FIRST_NAME", payload: newFirstName });
    };
    const setLastName = (newLastName: string) => {
        dispatch({ type: "SET_LAST_NAME", payload: newLastName });
    };

    return (
        <JoinCoordinator
            firstName={firstName}
            lastName={lastName}
            email={email}
            isLoading={isLoading}
            serverError={serverError}
            loginLink={"../" + AuthenticationViews.login}
            startJoin={startJoin}
            setEmail={setEmail}
            setFirstName={setFirstName}
            setLastName={setLastName}
        />
    );
};

export default JoinCoordinatorContainer;
